// src/hooks/useExternalScript.js
import { useEffect } from "react";

const useExternalScript = (src) => {
  useEffect(() => {
    if (document.querySelector(`script[src="${src}"]`)) return;
    const script = document.createElement("script");
    script.src = src;
    script.async = true;
    document.body.appendChild(script);
  }, [src]);

  useEffect(() => {
    // Poll every 100ms until the plugin is ready
    const handle = setInterval(() => {
      const $ = window.jQuery;
      if ($ && typeof $.fn.stellar === "function") {
        // Initialize Stellar with whatever options you like:
        $.stellar({
          horizontalScrolling: false,
          verticalOffset: 0,
        });
        clearInterval(handle);
      }
    }, 100);

    return () => clearInterval(handle);
  }, []);
};

export default useExternalScript;
